import { render } from "./DublineLogo.vue?vue&type=template&id=49c89727"
import script from "./DublineLogo.vue?vue&type=script&lang=js"
export * from "./DublineLogo.vue?vue&type=script&lang=js"
script.render = render

export default script